import { z } from "zod";
import { isDateRangeOrdered, isValidDateOrEmpty } from "../helpers/date";

/** ISO-4217 alphabetic currency code (upper case). */
export const currencyCodeSchema = z
  .string()
  .regex(/^[A-Z]{3}$/, { message: "currency_invalid" });

/** `RewardMoney` / {@link IMoney}: non-negative integer minor units + currency. */
export const moneySchema = z.object({
  amountMinor: z.number().int({ message: "amount_invalid" }).nonnegative({ message: "amount_invalid" }),
  currency: currencyCodeSchema,
});

/** Optional ISO-8601 date / date-time. Empty string is treated as "not set". */
export const optionalDateSchema = z
  .string()
  .refine(isValidDateOrEmpty, { message: "date_invalid" })
  .nullable()
  .optional();

/** Optional absolute http(s) URL (rejects `javascript:` and other schemes). */
export const optionalHttpUrlSchema = z
  .url({ protocol: /^https?$/, message: "url_invalid" })
  .nullable()
  .optional();

/** Whether a `startDate` / `endDate` window is ordered (compared as timestamps). */
export function isDateWindowOrdered(data: {
  startDate?: string | null;
  endDate?: string | null;
}): boolean {
  return isDateRangeOrdered(data.startDate, data.endDate);
}

/** Issue reported when {@link isDateWindowOrdered} fails. */
export function dateWindowIssue(): { message: string; path: string[] } {
  return { message: "date_range_invalid", path: ["endDate"] };
}
